import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { ENVIRONMENT, API_ENDPOINT_V1 } from "../../constants";

export const loginUser = createAsyncThunk("loginUser", async (userData) => {
  const { email, password } = userData;

  const response = await fetch(
    `${ENVIRONMENT}sessions?email=${encodeURIComponent(
      email
    )}&password=${encodeURIComponent(password)}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Length": 0,
      },
    }
  );

  return response.json();
});

export const getUser = createAsyncThunk("getUser", async (token) => {
  try {
    const userResponse = await fetch(
      `${API_ENDPOINT_V1}sso?include=profile.country,profile.city,user.billingaddress`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          tk: `Bearer ${token}`,
          // Altri header se necessario
        },
      }
    );

    const userData = await userResponse.json();
    return userData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

const userSlice = createSlice({
  name: "User",
  initialState: {
    isLoading: false,
    isError: false,
    data: null,
    user: {},
    walletAddress: "",
  },
  reducers: {
    setWalletAddress: (state, action) => {
      state.walletAddress = action.payload;
    },
    addItem: (state, action) => {
      state.push(action.payload);
    },
    resetUser: (state) => {
      console.log("dentro il resetUser");
      return {
        ...state,
        user: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      console.log("builder.addCase", action);
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;

      const token = action?.payload?.data?._token;
      localStorage.setItem("token", token);
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(getUser.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      console.log("builder.addCase", action);
      state.isLoading = false;
      state.isError = false;
      state.user = action.payload;

      if (action.payload?.error?.http_code === 401) {
        console.log("getUser.rejected:");
        console.log("Token scaduto. Rimuovo il token dal localStorage.");
        localStorage.removeItem("token");
        state.isError = true;
      }
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const getItemsSelector = createSelector(
  (state) => state.user,
  (state) => state
);

export const { addItem, resetUser, setWalletAddress } = userSlice.actions;

export default userSlice.reducer;
